import format from 'date-fns/format'
import parse from 'date-fns/parse'
import parseISO from 'date-fns/parseISO'
import { formatToTimeZone } from 'date-fns-timezone'

export default {
  methods: {
    dateForApi(date) {
      return format(date, 'yyyyMMdd')
    },
    timeForApi(date) {
      return format(date, 'HHmm')
    },
    dateForComponent(date) {
      return format(date, 'yyyy-MM-dd')
    },
    timeForComponent(date) {
      return format(date, 'HH:mm')
    },
    hourAsInteger(date) {
      return parseInt(format(date, 'HH'))
    },
    dateTimeForDisplay(date, tz=null) {
      if (tz) {
        return formatToTimeZone(date, 'DD/MM/YYYY HH:mm', { timeZone: tz })
      }
      return format(date, 'dd/MM/yyyy HH:mm')
    },
    timeDateForDisplay(date) {
      return format(date, 'HH:mm dd/MM/yyyy')
    },
    dateForDisplay(date) {
      return format(date, 'dd/MM/yyyy')
    },
    dateTimeForCountdown(date) {
      return format(date, 'yyyy-MM-dd HH:mm')
    },
    parseDate(string) {
      return parseISO(string)
    },
    parseApiDateTime(string) {
      return parse(string, 'yyyyMMddHHmm', new Date())
    }
  },
  computed: {
    dateTime() {
      if (this.date && this.time)
        return parse(this.date + ' ' + this.time, 'yyyy-MM-dd HH:mm', new Date())
      else if (this.date)
        return parse(this.date, 'yyyy-MM-dd', new Date())
    }
  }
}
